export default __webpack_public_path__ + "static/media/2.2fe7fa29.jpg";